import { useEffect, useState } from "react";
import useApiServices from "../../utils/useApiServices";
import swal from "sweetalert";
import { TELEGRAM_API_BASE_URL } from "../../utils/constant";

function SendAlert() {
  const [message, setMessage] = useState("");
  const [remark, setRemark] = useState("");
  const [mid, setMid] = useState("");
  const [groups, setGroups] = useState([]);
  const [status, setStatus] = useState({
    loading: false,
    error: "",
    success: "",
  });

  const { apiCallFnforPostForOpenUrl, apiCallFnforGetOpenUrl2 } =
    useApiServices();

  useEffect(() => {
    const loadGroups = async () => {
      setStatus((prev) => ({ ...prev, loading: true }));
      try {
        const res = await apiCallFnforGetOpenUrl2(
          `${TELEGRAM_API_BASE_URL}/merchant-group/getAllMerchantGroup`
        );
        const data = await res.json();
        if (data.status === "success") setGroups(data.data);
        else throw new Error("Failed to load groups");
      } catch (err) {
        setStatus((prev) => ({ ...prev, error: "Error fetching groups" }));
      } finally {
        setStatus((prev) => ({ ...prev, loading: false }));
      }
    };
    loadGroups();
  }, []);

  const handleSubmit = async () => {
    if (!message.trim()) return;

    const now = new Date();
    const date = now.toLocaleDateString("en-GB");
    const time = now.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });

    setStatus({ loading: true, error: "", success: "" });

    const payload = {
      alertMesage: message,
      date,
      mid,
      remark,
      time,
    };

    try {
      const res = await apiCallFnforPostForOpenUrl(
        `${TELEGRAM_API_BASE_URL}/send-message/sendAlertMessageInMerchantGroup`,
        payload
      );

      if (res?.statusCode === 200) {
        swal({
          title: "Success",
          text: "Alert sent successfully",
          icon: "success",
          button: "OK",
        });
        setMid("");
        setMessage("");
        setRemark("");
      } else {
        throw new Error("Failed to send alert");
      }
    } catch (err) {
      setStatus((prev) => ({
        ...prev,
        error: "Failed to send alert",
      }));
    } finally {
      setStatus((prev) => ({ ...prev, loading: false }));
    }
  };

  return (
    // <div className="d-flex justify-content-center">
    <div className="card shadow  w-100 p-4 border-2 border-gray">
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">🚨 Send Merchant Alert</h5>
      </div>
      <div className="mb-3 text-start px-4 mt-2">
        <label className="form-label fw-semibold text-start">
          Alert Message
        </label>
        <textarea
          rows="3"
          className="form-control"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Enter alert message"
        />
      </div>

      {/* MID */}
      <div className="d-flex gap-2  px-4">
        <div className="mb-3 text-start w-50">
          <label className="form-label fw-semibold text-start">Enter MID</label>
          <input
            type="text"
            className="form-control"
            value={mid}
            onChange={(e) => setMid(e.target.value)}
            placeholder="Enter MID"
          />
        </div>

        {/* Message */}

        {/* Remark */}
        <div className="mb-4 text-start w-50">
          <label className="form-label fw-semibold text-start">
            Remark (optional)
          </label>
          <input
            type="text"
            className="form-control"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            placeholder="Enter remark"
          />
        </div>
      </div>
      <div className="px-4">
        {status.error && (
          <div className="alert alert-danger">{status.error}</div>
        )}
      </div>

      <div className="p-4 d-flex justify-content-end ">
        <button
          className="btn btn-primary rounded-none w-10 fw-semibold"
          onClick={handleSubmit}
          disabled={status.loading}
        >
          {status.loading ? "Sending..." : "Send Alert"}
        </button>
      </div>
    </div>
  );
}

export default SendAlert;
